

























































import Vue from 'vue';
import { mapState } from 'vuex';

import FilterValue from '@/types/FilterValue';

export default Vue.extend({
	name: 'SearchFilter',

    props: {
        value: FilterValue
	},

    data() {
        return {
			showFilter: false,
			searchTemp: ''
        };
    },

	created() {
		this.showFilter = this.value && (this.value.searchText !== '' || this.value.tagIds.length > 0);
	},

	computed: {
		...mapState(['tags', 'language']),

        modifier: {
            get(): FilterValue {
                return this.value;
            },
            set(modifier: FilterValue) {
                this.$emit('value', modifier);
            }
        }
	},

	methods: {
		toogleFilter(): void {
			this.showFilter = !this.showFilter;
		},

        selectTag(tagId: string): void {
			this.$set(this.modifier.tagIds, this.modifier.tagIds.length, tagId);
        },

        unSelectTag(tagId: string): void {
			const index = this.modifier.tagIds.indexOf(tagId);
			if (index > -1) {
				this.modifier.tagIds.splice(index, 1);
			}
        },

        isSelectedTag(tagId: string): boolean {
            return new Set(this.modifier.tagIds).has(tagId);
        },

		resetFilter(): void {
			this.modifier.tagIds = new Array<string>();
			this.removeSearch();
		},

		search(): void {
			this.modifier.searchText = this.searchTemp;
		},

		removeSearch(): void {
			this.modifier.searchText = '';
			this.searchTemp = '';
		}
	}
});
